import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { Popover } from '@flowwai-frontend/design-system'
import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { DotsHorizontal } from '@flowwai-frontend/design-system/icons'

import { ActionInterface } from '../BoardActions.types'
import OptionItem from '../OptionItem/OptionItem'
import { getTriggerStyles, popoverContentClassName } from './styles'

interface Props {
   actions: ActionInterface[]
   onAction: (id: string) => void
   isOpen: boolean
   setIsOpen: (isOpen: boolean) => void
}

const BoardItemActionsPopover = (props: Props): React.ReactElement => {
   const { actions, onAction, isOpen, setIsOpen } = props

   const { theme } = useAppTheme()
   const { boardActions: boardActionsTheme } = theme.boards
   const t = useCustomT('boards:common')

   const renderIcon = (iconId: string): React.ReactElement => (
      <svg width={16} height={16} fill='none'>
         <use xlinkHref={`/assets/icons/iconsSprite.svg#${iconId}`} />
      </svg>
   )

   const renderPopoverContent = (): React.ReactElement => (
      <div
         className={cn(popoverContentClassName, boardActionsTheme.borderColor)}
      >
         {actions.map(action => (
            <OptionItem
               key={action.id}
               name={action.name}
               rightEnhancer={() => renderIcon(action.iconId)}
               onAction={() => onAction(action.id)}
               hasDivider={action.hasDivider}
               isDeleteAction={action.isDeleteAction}
            />
         ))}
      </div>
   )

   const renderTrigger = (): React.ReactElement => (
      <div
         className={getTriggerStyles(isOpen, boardActionsTheme)}
         title={t('more')}
      >
         <DotsHorizontal
            width={16}
            height={16}
            fill={boardActionsTheme.dotsHorizontalIconColor}
         />
      </div>
   )

   return (
      <Popover
         renderPopoverTrigger={renderTrigger}
         renderPopoverBody={renderPopoverContent}
         isOpen={isOpen}
         onOpenChange={setIsOpen}
         offset={12}
         placement={'top start'}
      />
   )
}

export default observer(BoardItemActionsPopover)
